module.exports = __webpack_public_path__ + "static/img/333.2c81b36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/333.png
// module id = 6Xze
// module chunks = 1